import { Component, OnInit, AfterViewInit } from '@angular/core';

import { EventService } from '../core/services/event.service';

@Component({
  selector: 'app-layout-user',
  templateUrl: './layout-user.component.html',
})

export class LayoutUserComponent implements OnInit, AfterViewInit {

  // layout-user related config
  layoutType: string;
  constructor(private eventService: EventService) { }

  ngOnInit() {
    this.layoutType = 'horizontal';
    this.eventService.subscribe('changeLayout', (layout) => {
      this.layoutType = layout;
    });
  }

  ngAfterViewInit(): void {

  }
}
